import { Spinner, Button, Badge, Table, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import { AppContext } from '../context/AppContext';
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Header from '../Common/Header';
import Footer from '../Common/Footer';

const DaneCountReport = () => {
  const { token, currentUser } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [reportData, setReportData] = useState(null); // State for report data
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [startDate, setStartDate] = useState(""); // State for start date
  const [endDate, setEndDate] = useState(""); // State for end date

  // Fetch donor statistics report
  const fetchReportData = async () => {
    try {
      let baseURL = process.env.REACT_APP_API_BASE_URL + `DaneDates/donorreport`;
      let headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      };

      // Add optional date range query parameters
      let queryParams = "";
      if (startDate) queryParams += `startDate=${startDate}&`;
      if (endDate) queryParams += `endDate=${endDate}`;

      const response = await axios.get(`${baseURL}?${queryParams}`, { headers });
      //const response = await axios.get(`${baseURL}`, { headers });
      setReportData(response.data);

//console.log("================");
//console.log(response.data);

    } catch (error) {
      console.error("Error fetching report data:", error);
      setError(error.message || "Unable to fetch report data.");
    }
  };

  return (
    <>
      {(currentUser.accesstype === "admin" || currentUser.accesstype === "superadmin") && (
        <Container fluid="md" style={{ marginTop: '5px' }}>
          <Header currentUser={currentUser} titletext={"Donations"} />
          <br />

          {/* Report Section */}
          <Row className="mb-3">
            <Col>
              <h4>Devotees Dane Statistics Report</h4>
              <Form>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm={2}>Start Date</Form.Label>
                  <Col sm={4}>
                    <Form.Control
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </Col>
                  <Form.Label column sm={2}>End Date</Form.Label>
                  <Col sm={4}>
                    <Form.Control
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </Col>
                </Form.Group>
                <Button variant="primary" onClick={fetchReportData}>
                  Generate Report
                </Button>
              </Form>

              {/* Display Report Data */}
              {reportData && (
                <>
                  <h5 className="mt-4">Heel Dane Devotees</h5>
                  <Table bordered hover responsive="sm" size="sm" variant="light">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Dane Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.heelDonors.map((donor, index) => (
                        <tr key={index}>
                          <td>{donor.name}</td>
                          <td>{donor.phone}</td>
                          <td>{donor.count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <h5 className="mt-4">Dahawal Dane Devotees</h5>
                  <Table bordered hover responsive="sm" size="sm" variant="light">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Dane Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.dahawalDonors.map((donor, index) => (
                        <tr key={index}>
                          <td>{donor.name}</td>
                          <td>{donor.phone}</td>
                          <td>{donor.count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  {/* Summary */}
                  <h5 className="mt-4">Summary</h5>
                  <p><b>Total Heel Dane Offerings:</b> {reportData.totalHeelDonations}</p>
                  <p><b>Total Dahawal Dane Offerings:</b> {reportData.totalDahawalDonations}</p>
                </>
              )}

              {/* Error Handling */}
              {error && (
                <>
                  <div className="alert alert-danger mt-3">{error}</div>
                </>
              )}
            </Col>
          </Row>

          {/* Existing Donor Listing Section */}
          {/* ... Existing donor listing code remains unchanged ... */}

          {/* Footer */}
          <Footer currentUser={currentUser} />
        </Container>
      )}
    </>
  );
};

export default DaneCountReport;
